import React from 'react'
import "./Loder.css"
export default function PageLoder() {
  return (
    <div class="lds-ripple"><div></div><div></div></div>
  )
}
